
import {of as observableOf,  Observable } from 'rxjs';

import {filter, withLatestFrom, tap, takeUntil, catchError} from 'rxjs/operators';
import { HttpClient, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoopBackConfig } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import * as actions from '../actions/file-upload.actions';
import { CAAction } from '../actions/index';
import { State as AuthState } from '../reducers/auth.reducer';
import * as selectors from '../reducers/index';

@Injectable()
export class FileUploadEffects {
  @Effect({ dispatch: false })
  uploadStart = this.actions$
    .ofType(actions.REQUEST_FILE_UPLOAD_START).pipe(
    withLatestFrom(
      this.store.select(selectors.getAuthenticationState),
      this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))
    ),
    tap(([source, state, organisationId]) => {
      this.createRequest(source, state, organisationId).pipe(
        takeUntil(
          this.actions$.ofType(actions.REQUEST_FILE_UPLOAD_CANCEL).pipe(filter(s => {
            return s.payload.id === source.payload.id;
          }))
        ),
        catchError(err => {
          return observableOf(new actions.ResponseFileUploadErrorAction(err));
        }),)
        .subscribe((event: any) => {
          switch (event.type) {
            case HttpEventType.Response:
              return this.store.dispatch(
                new actions.ResponseFileUploadCompleteAction({
                  id: source.payload.id,
                  type: source.payload.type,
                  response: event.body
                })
              );
            case HttpEventType.Sent:
            case HttpEventType.UploadProgress:
            case HttpEventType.ResponseHeader:
            case HttpEventType.DownloadProgress:
              return this.store.dispatch(
                new actions.ResponseFileUploadProgressAction({
                  id: source.payload.id,
                  progress: this.progress(event)
                })
              );
            case actions.RESPONSE_FILE_UPLOAD_ERROR:
              return this.store.dispatch(event);
          }
          throw {
            id: source.payload.id,
            response: event.body
          };
        });
    }),);

  constructor(
    private store: Store<any>,
    private actions$: Actions<CAAction>,
    private http: HttpClient
  ) {}

  progress(event) {
    const loaded = event.loaded || 0;
    const total = event.total || 100;
    let percent = 100 * loaded / total;
    switch (event.type) {
      case HttpEventType.UploadProgress:
        percent = percent * 0.75;
        break;
      case HttpEventType.ResponseHeader:
        percent = 75;
        break;
      case HttpEventType.DownloadProgress:
        percent = 75 + percent * 0.25;
        break;
      case HttpEventType.Response:
        percent = 100;
        break;
    }
    return percent;
  }

  buildFormData(file) {
    let formData = new FormData();
    formData.append('file[]', file);
    return formData;
  }

  createRequest(source: CAAction, state: AuthState, organisationId: string) {
    const request = new HttpRequest(
      'POST',
      LoopBackConfig.getPath() +
        '/' +
        LoopBackConfig.getApiVersion() +
        `/organisations/${organisationId}/${source.payload.url || 'upload'}`,
      this.buildFormData(source.payload.file),
      {
        responseType: 'json',
        reportProgress: true,
        headers: new HttpHeaders().set('Authorization', state.auth.id)
      }
    );
    return this.http.request(request);
  }
}
